import axios from 'axios';
import {Message} from "element-ui";
const apiUrl = process.env.VUE_APP_BASE_API;

const service = axios.create({
  baseURL: apiUrl,
  timeout: 30000
});

//request拦截器
service.interceptors.request.use(config => {
  if (config.params) {
    for (let [k, v] of Object.entries(config.params)) {
      config.url += `/${v}`;
    }
    config.params = null
  }
  if (config.query) {
    config.url += '?';
    for (let [k, v] of Object.entries(config.query)) {
      if(v ){
        config.url += `${k}=${v}&`;
      }

    }
    config.url = config.url.substr(0, config.url.length - 1);
    config.query = null;
  }

  return config
});

//response拦截器
service.interceptors.response.use(response => {
  if(response.config.responseType === "blob"){
    return response;
  }else{
    const res = response.data;
    if (res.code !== 0) {
       const showMessageError = [10009];
       const showcustomizeError = [10090, 10020, 10010,10021, 10022, 10081,10012,10082,10013,10014];
      if (res.code === 999) {//未知错误
      }else if(res.code === 10011){
         // Message.error({
         //   message: '您的登录信息已过期，请重新登录'
         // });

        // MessageBox.confirm('您的登录信息已过期，请重新登录').then(() => {
        //   router.go(0);
        // })
       // window.location.reload();
        return res;
      }
      else if (showMessageError.includes(res.code)) {
        Message.error({
          message: res.msg
        });
        return res
      }
      else if (showcustomizeError.includes(res.code)) {
        return res
      }
       else {
        return Promise.reject({code: res.code, msg: res.msg});
       }
    } else {

      return res

    }
  }
  },
  error => {
    if (error.response === undefined) {
      Message.error({
        message: '请确认设备是否已接入网络。'
      });
    }
    return Promise.reject(error);
  }
);

export default service;
